module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Cms', {
    attrs: {
      "pageTitle": 'Conteúdo da Página de Empresas',
      "pageName": 'companies'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee251d34","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cms/CompaniesCms.vue
// module id = 714
// module chunks = 1